// shared.js から移行: カスタムカーソル / reveal / カウンター
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.#setupCursor()
    this.#setupReveal()
    this.#setupCounters()
  }

  disconnect() {
    document.querySelector(".cur")?.remove()
    document.querySelector(".cur-r")?.remove()
    if (this._onMouseMove) document.removeEventListener("mousemove", this._onMouseMove)
    if (this._onMouseOver) document.removeEventListener("mouseover", this._onMouseOver)
    if (this._stopTrack) this._stopTrack()
  }

  #setupCursor() {
    const cur = document.createElement("div")
    cur.className = "cur"
    const curR = document.createElement("div")
    curR.className = "cur-r"
    document.body.appendChild(cur)
    document.body.appendChild(curR)

    let mx = innerWidth / 2, my = innerHeight / 2
    let rx = mx, ry = my
    let alive = true

    this._onMouseMove = (e) => {
      mx = e.clientX; my = e.clientY
      cur.style.left = mx + "px"; cur.style.top = my + "px"
    }
    document.addEventListener("mousemove", this._onMouseMove)

    const track = () => {
      if (!alive) return
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18
      curR.style.left = rx + "px"; curR.style.top = ry + "px"
      requestAnimationFrame(track)
    }
    track()
    this._stopTrack = () => { alive = false }

    this._onMouseOver = (e) => {
      const h = e.target.closest("a, button, .hover-target")
      curR.style.width = h ? "60px" : "36px"
      curR.style.height = h ? "60px" : "36px"
      curR.style.borderColor = h ? "var(--accent)" : "rgba(244,240,232,0.4)"
    }
    document.addEventListener("mouseover", this._onMouseOver)
  }

  #setupReveal() {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target) }
      })
    }, { threshold: 0.15 })
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el))
  }

  #setupCounters() {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return
        const el = e.target
        const target = parseFloat(el.dataset.count)
        const dec = parseInt(el.dataset.decimals || "0", 10)
        const dur = 1400; const start = performance.now()
        const fn = (t) => {
          const p = Math.min(1, (t - start) / dur)
          const eased = 1 - Math.pow(1 - p, 3)
          el.textContent = (eased * target).toFixed(dec)
          if (p < 1) requestAnimationFrame(fn)
        }
        requestAnimationFrame(fn)
        cio.unobserve(el)
      })
    }, { threshold: 0.5 })
    document.querySelectorAll("[data-count]").forEach((el) => cio.observe(el))
  }
}
